import { TableUi } from "./Power";

const Fucntions = () => (
  <TableUi
    title="Functions"
    header="Obligatory functions are as detailed in Sec. 29 of the KMC Act, 1980. And discretionary functions are as detailed in Sec.30 of the KMC Act, 1980. Besides these, exercising of general functions are subject to KMC Act, Rules and Regulations."
    list={[
      "Water Works & Water Supply",
      "Drainage & Sewerage",
      "Street Lighting & Electricals",
      "Roads & Pathways",
      "Parks & Gardens",
      "Land Use Control & Building",
      "Solid Waste Management",
      "Preventive & Curative Health Care",
      "Town Planning & Architecture",
      "Survey & Record",
      "Municipal Markets",
      "Improvement of Slums (Bustees)",
      "Primary Education",
      "Information & Public Relations",
    ]}
  />
);

export default Fucntions;
